module.exports = __webpack_public_path__ + "static/media/20ECE24.dea5032c.jpg";